import { h } from "preact";
import { TABS } from "./constants";
import BlogCard from "../main-blog/blog-card";
import useBlogCardHeights from "../helpers/useBlogCardHeights";

export default function ({ articles, activeTab, translations }) {
  const style = activeTab === TABS.articles ? {} : { display: "none" };
  const [trackHeight, cardContentHeight] = useBlogCardHeights();

  const items = articles?.map((article) => (
    <BlogCard
      article={article}
      key={article.handle}
      minHeight={cardContentHeight}
      trackHeight={(height) => trackHeight({ id: article.id, height })}
    />
  ));

  return (
    <div
      role="tabpanel"
      aria-labelledby={`search-tab-${TABS.articles}`}
      className="main-search__page-results-wrapper"
      style={style}
    >
      {!articles ? null : !articles.length ? (
        <div className="main-search__no-item-results">
          {translations.page_no_results}
        </div>
      ) : (
        <div className="main-search__page-results search-blog__wrapper">
          {items}
        </div>
      )}
    </div>
  );
}
